
import useGetQueryPagination from "./helper/ueGetPagination";
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetOneQuery from "./helper/useGetOneQuery";
import useUpdateMutation from "./helper/useUpdateMutation";
  
const API = {
  ADD: `developer`,
  GET_ALL: `developer`,
  DELETE: `developer`,
  UPDATE: `developer`,

};
const KEY = "developer"


export const useGetDeveloper = (params?:any) => useGetQueryPagination(KEY, API.GET_ALL,params);
export const useGetOneDeveloper = () => useGetOneQuery(KEY, API.GET_ALL);

export const useAddDeveloper = () => useAddMutation(KEY, API.ADD);
export const useUpdateDeveloper = () => useUpdateMutation(KEY, API.UPDATE,true);

export const useDeleteDeveloper = () =>useDeleteMutation(KEY, API.DELETE);
